
import { Database } from '@/integrations/supabase/types';

export interface BusinessData {
  id?: string;
  name: string;
  industry: string;
  industry_enum?: Database['public']['Enums']['business_industry'] | string;
  website?: string;
  description?: string;
  brandVoice?: string;
  targetAudience?: string;
  companySize?: string;
  keywords?: string[];
  businessTags?: string[];
  socialMedia?: Record<string, string> | null;
  marketingEfforts?: string;
  brandGuidelines?: string;
  brandGuidelinesFilePath?: string;
  colors?: string[];
  lastAnalyzedAt?: number;
  is_onboarding_complete?: boolean;
  subscription_status?: string;
  plan_name?: string;
  current_period_end?: string;
  stripe_subscription_id?: string;
}

export interface BusinessSubscriptionDetails {
  status: string;
  planName: string;
  endDate: string | null;
}

export const BUSINESS_INDUSTRIES = [
  'Technology',
  'Healthcare',
  'Education',
  'Finance',
  'Retail',
  'Manufacturing',
  'Real Estate',
  'Hospitality',
  'Entertainment',
  'Media',
  'Legal Services',
  'Consulting',
  'Construction',
  'Transportation',
  'Agriculture',
  'Energy',
  'Non-profit',
  'Other'
] as const;

export type BusinessIndustry = typeof BUSINESS_INDUSTRIES[number];
